import React from "react";
import { Link } from "react-router-dom";
import { BRAND_NAME } from "../data/contactInfo";
import "../styles/BrandLogo.css";

export const BRAND_LOGO_SRC = `${process.env.PUBLIC_URL}/thiruvam_logo.png`;

const BrandLogo = ({
  size = "md",
  linked = false,
  showName = false,
  name = BRAND_NAME,
  tagline = "",
  className = "",
  onClick,
}) => {
  const content = (
    <>
      <img
        src={BRAND_LOGO_SRC}
        alt={BRAND_NAME}
        className={`brand-logo brand-logo--${size}`}
      />
      {showName && (
        <div className="brand-logo-text">
          <span className="brand-logo-name">{name}</span>
          {tagline ? <span className="brand-logo-tagline">{tagline}</span> : null}
        </div>
      )}
    </>
  );

  const wrapClass = `brand-logo-wrap brand-logo-wrap--${size}${showName ? " brand-logo-wrap--with-text" : ""} ${className}`.trim();

  if (linked) {
    return (
      <Link to="/" className={wrapClass} onClick={onClick}>
        {content}
      </Link>
    );
  }

  return <div className={wrapClass}>{content}</div>;
};

export default BrandLogo;
